<template>
    <div class="setting-component">
        <!-- [ Menu ] end -->
        <div class="wrap">
            <div class="wrap__tree">
                <div class="nav-tree">
                    <el-button @click="openModalAdd('create')" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">Add {{btnText}}</el-button>
                </div>
                <el-table
                        :data="tableData"
                        :empty-text="$t('general_noData')"
                        style="width: 100%">
                    <el-table-column
                      label="ID"
                      type="index"
                      width="50">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="Name">
                    </el-table-column>
                    <el-table-column
                            prop="createDate"
                            label="Created On"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            width="120"
                            label="Operations">
                        <template slot-scope="scope">
                            <el-button
                                    size="mini"
                                    type="primary"
                                    plain
                                    icon="el-icon-edit"
                                    @click="openModalAdd('update', scope.$index, scope.row)"></el-button>
                            <el-button
                                    size="mini"
                                    type="danger"
                                    plain
                                    icon="el-icon-delete"
                                    @click="handleDelete(scope.$index, scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <sweet-modal blocking ref="openModalEdit"  class="modal" v-on:close="closeModalEdit">
            <h1>Edit {{btnText}}</h1>
            <el-form :model="formEdit" ref="formEdit" status-icon :rules="rulesEdit" label-width="0" class="demo-ruleForm">
                <el-form-item prop="name">
                    <el-input placeholder="Category Name" v-model="formEdit.name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="editItem('formEdit')" class="modal__btn" type="primary" plain size="small">Edit {{btnText}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
        <createCompanyCategoryModal @loadList="loadList" ref="createCompanyCategoryModal"/>
        <sweet-modal blocking ref="confirmation" :title="`Delete ` + btnText">
            Are you sure you want to delete this {{btnText}}?
            <template slot="box-action">
                <el-button class="button" @click="deleteConfirm">Delete {{btnText}}</el-button> &nbsp;
            </template>
        </sweet-modal>
    </div>
</template>

<script>
  // import Header from '@/components/Header.vue'
  // import Menu from '@/components/Menu.vue'
  import createCompanyCategoryModal from '@/components/settings/companyCategories/createCompanyCategoryModal'

  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    name: 'company-categories',
    components: {
      // Header,
      // Menu,
      // AgGridVue,
      SweetModal,

      createCompanyCategoryModal
    },
    beforeCreate() {
    },
    beforeMount() {

    },
    computed: {

    },
    mounted(){

    },
    data() {
      return {
        paleceholderText: 'Category',
        btnText:'Category',
        tableData: [],
        selectedRowId: '',
        moment:moment,
        state: 'companyCategories',
        form:{
          name: ''
        },
        formEdit:{
          name: ''
        },
        rules: {
          name: [
            { required: true, message: 'Field is required', trigger: 'blur' }
          ]
        },
        rulesEdit: {
          name: [
            { required: true, message: 'Field is required', trigger: 'blur' }
          ]
        },
      }
    },
    methods: {
      loadList(state){
        let loader = this.$loading.show();
        this.state = state
        if(state === 'companyCategories'){
          this.btnText = 'Category'
          this.paleceholderText = 'Category'
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${state}/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.tableData = response.data.list
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      openModalAdd(operation, index, row){
        if(operation === 'create'){
          // this.form.nameList = response.data.businessUnitTypeNameList
          this.$refs.createCompanyCategoryModal.openModal()
        }else if(operation === 'update'){
          // this.formEdit.nameList = response.data.businessUnitTypeNameList
          this. handleEdit(index, row)
        }
        // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        // axios
        //   .post(`/api/v1/${this.state}/directories?companyId=${this.$route.query.companyId}&operation=${operation}`)
        //   .then(response => {
        //     if(operation === 'create'){
        //       // this.form.nameList = response.data.businessUnitTypeNameList
        //       this.$refs.createCompanyCategoryModal.openModal()
        //     }else if(operation === 'update'){
        //       // this.formEdit.nameList = response.data.businessUnitTypeNameList
        //       this. handleEdit(index, row)
        //     }
        //   })
        //   .catch(error => {
        //     console.log('An error occurred:', error);
        //   });
      },
      openModalEdit(){

      },
      openModalDelete(){

      },
      // addItem(form){
      //   this.$refs[form].validate((valid) => {
      //     if (valid) {
      //       let data = {
      //         name: this.form.name
      //       }
      //       axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //       axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //       axios
      //         .post(`/api/v1/${this.state}/create?companyId=${this.$route.query.companyId}`, data)
      //         .then(response => {
      //           this.notification("Success", `Add ${this.btnText}`, "success");
      //           this.$refs.openModal.close()
      //           this.loadList(this.state)
      //         })
      //         .catch(error => {
      //           console.log('An error occurred:', error);
      //         });
      //     }else {
      //       console.log('error submit!!');
      //       return false;
      //     }
      //   });
      // },
      // closeModal(){
      //   // this.form.no = ''
      //   this.form.name = ''
      //   this.$refs['form'].resetFields();
      // },
      closeModalEdit(){
        // this.formEdit.no = ''
        this.formEdit.name = ''
        this.$refs['formEdit'].resetFields();
      },
      handleEdit(index, row) {
        this.selectedRowId = row.id
        let loader = this.$loading.show();
        let Id = 'companyCategoryId'
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${this.state}/item?companyId=${this.$route.query.companyId}&${Id}=${row.id}`)
          .then(response => {
            this.$refs.openModalEdit.open()
            this.formEdit.name = response.data.item.name
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      editItem(formEdit){
        this.$refs[formEdit].validate((valid) => {
          if (valid) {
            let data = {
              name: this.formEdit.name,
            }
            let loader = this.$loading.show();
            let Id = 'companyCategoryId'
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/${this.state}/update?companyId=${this.$route.query.companyId}&${Id}=${this.selectedRowId}`, data)
              .then(response => {
                this.notification("Success", `Edit ${this.btnText}`, "success");
                this.$refs.openModalEdit.close()
                this.loadList(this.state)
                loader.hide()
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleDelete(index, row) {
        console.log(row.id)
        // this.$refs.confirmation.open()
        this.selectedRowId = row.id
        console.log(row)

        this.$confirm('This will permanently delete the category. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          let Id = 'companyCategoryId'
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/${this.state}/delete?companyId=${this.$route.query.companyId}&${Id}=${this.selectedRowId}`)
            .then(response => {
              this.$refs.confirmation.close()
              this.loadList(this.state)
              this.notification("Success", `Delete ${this.btnText}`, "success");
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      deleteConfirm(){
        let Id = 'companyCategoryId'
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${this.state}/delete?companyId=${this.$route.query.companyId}&${Id}=${this.selectedRowId}`)
          .then(response => {
            this.$refs.confirmation.close()
            this.loadList(this.state)
            this.notification("Success", `Delete ${this.btnText}`, "success");
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      showMenu() {
        this.open = true
        console.log('---', this.open);
      },
      hideMenu() {
        this.open = false
        console.log('---', this.open);
      },
      companyName(name) {
        this.companyNameSelect = name
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    },
    watch:{
      tableData(val){
        val.forEach(i =>{
          i.createDate = moment(i.createDate.toString(), 'X').format('DD MMM YYYY')
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
    .setting-component{
        min-width:810px;
    }
    .sweet-modal-overlay{
        z-index:10;
    }
    /deep/.el-notification .right{
        z-index: 9999999;
    }
</style>

<style>

</style>
